const SE = {
  governmentalOrganization: [
    "kommuner",
    "landsting"
  ],
  listedPublicCompany: [
    "publikt aktiebolag (AB publ)"
  ],
  nonProfit: [
    "ideell förening"
  ],
  privateCompany: [
    "aktiebolag (Ab)"
  ]
};
export {
  SE as default
};
